import { useState, useEffect } from "react";

export default function useIsOnScreen(element, rootMargin = "0px") {
  const [isVisible, setState] = useState(false);

  useEffect(() => {
    if (element?.current) {
      const observer = new IntersectionObserver(
        ([entry]) => {
          setState(entry.isIntersecting);
        },
        { rootMargin },
      );

      if (element.current) {
        observer.observe(element.current);
      }

      return () => {
        if (element?.current) {
          observer.unobserve(element.current);
        }
      };
    }
  }, [element?.current]);

  return isVisible;
}
